import { gridSideModalComponentProps } from "../../../../../core/grids/GridSideModals";
import ModalContext from "../../../../../core/modalZ/context/ModalContext";
import { Animations } from "../../../../../core/util/Animations";
import { CardProps } from "../../view/components/KanbanBoard/KanbanBoard";
import PerspectiveModal from "./PerspectiveModal/PerspectiveModal_view";

export const SHOW_PERSPECTIVE_MODAL = (card: CardProps) => {
  ModalContext.show({
    showClose: true,
    title: null,
    content: <PerspectiveModal card={card} />,
    componentProps: {
      ...gridSideModalComponentProps,
      wrapHeight: "default",
      wrapWidth: "large",
      position: "middle",
      className: "modal__grid-link"
    },
    animationOptions: {
      animateIn: Animations.SLIDE_IN_UP,
      animateOut: Animations.SLIDE_OUT_DOWN
    }
  });
};
